import {
  ReportChecklistAccessoriesData,
  ReportChecklistData,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  checklist: ReportChecklistData;
}

const ReportChecklistBoschAccessories: React.FC<Props> = ({ checklist }) => {
  const firstList = checklist.accessories?.slice(
    0,
    Math.round(checklist.accessories.length / 3),
  );
  const secondList = checklist.accessories?.slice(
    Math.round(checklist.accessories.length / 3),
    Math.round(checklist.accessories.length / 3) * 2,
  );
  const thirdList = checklist.accessories?.slice(
    Math.round(checklist.accessories.length / 3) * 2,
    checklist.accessories.length,
  );

  function renderTable(data?: ReportChecklistAccessoriesData[]) {
    return (
      <table className="reportChecklist-accessoriesBosch-table -bosch">
        <thead>
          <tr>
            <th>Acessórios</th>
            <th>Sim</th>
            <th>Não</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => (
            <tr key={item.accessoryId}>
              <td>{item.description}</td>
              <td>X</td>
              <td></td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <div className="reportChecklist-accessoriesBosch">
      {renderTable(firstList)}
      {renderTable(secondList)}
      {renderTable(thirdList)}
    </div>
  );
};

export default ReportChecklistBoschAccessories;
